import React from "react";
import { mutationCreateTicket, mutationUpdateTicket, queryGetTickets, queryGetTicketDocuments } from "../../../queries/querySettings";
import { Dropdown } from "office-ui-fabric-react/lib/Dropdown";
import { ComboBox, Label, IconButton } from "office-ui-fabric-react/lib/";
import Utils from "./../../common/Utils";
import { DefaultButton, PrimaryButton, Stack, TextField, TooltipHost, FontIcon } from "office-ui-fabric-react";
import { toast } from "react-toastify";
import { MyContext } from "../../../context";
import "../fabric-icons-inline.css";

const dropdownStyles = {
    dropdown: { width: 250 },
};


export default class AddTenant extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.allowedTenantsList = [];
        // Collect Tenant ComboBox
        if (this.props.userRules.allowedTenants != null) {
            for (let x = 0; x < this.props.userRules.allowedTenants.length; x++) {
                this.allowedTenantsList.push({ key: this.props.userRules.allowedTenants[x].id, text: this.props.userRules.allowedTenants[x].name });
            }
        }

        if (this.props.data != null && this.props.data !== undefined) {
            this.state = {
                title: this.props.data.title,
                priority: this.props.data.priority,
                caseId: this.props.data.caseId,
                state: this.props.data.state,
                id: this.props.data.id,
                description: this.props.data.description,
                created: this.props.data.created,
                changed: this.props.data.changed,
                tenantId: this.props.data.tenantId,
                contactEmail: this.props.data.contactEmail,
                isChecked: false,
                showModal: false,
                comment: "",
                files: [],
                deletedFiles: []

            }
        }
        else {
            this.state = {
                title: "",
                priority: "",
                caseId: "",
                state: "",
                description: "",
                contactEmail: "",
                id: null,
                created: "",
                changed: "",
                isChecked: false,
                showModal: false,
                comment: "",
                documentUpload: "",
                files: [],
                deletedFiles: []
            }
        }
    }

   

    validateEmail = (email) => {
        if (!email) return true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    styles = {
        root: {
            paddingTop: "20px",
        },
    };

    render() {
        return (
            <Stack vertitcal>
                <Stack.Item styles={this.styles}>
                    <Stack>
                        <Stack.Item>
                            {this.props.userRules.allowedTenants != null && this.props.userRules.allowedTenants.length > 0 && (
                                <Stack.Item>
                                    <ComboBox
                                        defaultSelectedKey={this.state.tenantId}
                                        selectedKey={this.state.tenantId}
                                        options={this.allowedTenantsList}
                                        label={"TenantId"}
                                        onChange={(ev, newVal) => {
                                            this.setState({
                                                tenantId: newVal.key,
                                            });
                                        }}
                                    />
                                </Stack.Item>
                            )}

                            <TextField
                                label={<MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketTitle")}</>}</MyContext.Consumer>}
                                onChange={(event) => {
                                    this.handleChange(event.target.value, 0);
                                }}
                                value={this.state.title}
                                onKeyDown={this._handleKeyDown}
                            />
                            <TextField
                                label={
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <MyContext.Consumer>{(context) => <> {context.getTranslation("detailContainer", "email")}</>}</MyContext.Consumer>
                                        <TooltipHost content="Add your email." styles={{ root: { marginLeft: 6 } }}>
                                            <FontIcon iconName="Info" style={{ cursor: 'pointer', fontSize: 14 }} />
                                        </TooltipHost>
                                    </div>
                                }
                                onChange={(event) => {
                                    this.handleChange(event.target.value, 4);
                                }}
                                value={this.state.contactEmail}
                                onKeyDown={this._handleKeyDown}
                                errorMessage={this.state.contactEmail && !this.validateEmail(this.state.contactEmail) ? "Invalid email address" : ""}
                            />
                            <Dropdown
                                selectedKey={this.state.priority}
                                onChange={(event, item) => {
                                    this.handleChange(item.key, 1);
                                }}
                                label={<MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketPriority")}</>}</MyContext.Consumer>}
                                options={[
                                    { key: "SOS", text: "SOS" },
                                    { key: "Critical", text: "Prio 1" },
                                    { key: "Major", text: "Prio 2" },
                                    { key: "Minor", text: "Prio 3" },
                                ]}
                                styles={dropdownStyles}
                            />
                            {/*upload a file*/}
                            <Label>{<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "uploadDocument")}</>)}</MyContext.Consumer>}</Label>
                            <div>
                                <input type="file" onChange={this.onFileChange} id="file-btn" style={{ display: 'none' }} />
                                <DefaultButton text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "Upload")}</>)}</MyContext.Consumer>} onClick={() => document.getElementById('file-btn').click()} />
                            </div>


                            {/* Display uploaded files */}
                            {this.state.files.length > 0 && <Label>{<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "attachedDocuments")}</>)}</MyContext.Consumer>}</Label>}

                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                                {this.state.files.map((file, index) => (
                                    <li key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <IconButton
                                            iconProps={{ iconName: 'Delete' }}
                                            title="Delete"
                                            ariaLabel="Delete"
                                            onClick={() => this.deleteFile(index)}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <a href={file.documentBody} download={file.filename}>
                                            {file.filename}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                            <TextField
                                label={<MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketDescription")}</>}</MyContext.Consumer>}
                                onChange={(event) => {
                                    this.handleChange(event.target.value, 3);
                                }}
                                value={this.state.description}
                                onKeyDown={this._handleKeyDown}
                                multiline
                                rows={10}
                            />
                        </Stack.Item>
                    </Stack>
                </Stack.Item>

                <Stack.Item styles={this.styles}>
                    <Stack horizontal>
                        <Stack.Item>

                            <PrimaryButton
                                id="saveBtn"
                                onClick={(event) => {
                                    this.notifyTenantChange(this.props.apol);
                                    this.props.cl();
                                }}
                                text={<MyContext.Consumer>{(context) => <> {context.getTranslation("common", "save")}</>}</MyContext.Consumer>}
                                disabled={!this.state.isChanged}
                            />
                        </Stack.Item>
                        <Stack.Item style={{ marginLeft: '10px' }}>
                            <DefaultButton
                                onClick={(event) => {
                                    this.props.cl();
                                }}
                                text={<MyContext.Consumer>{(context) => <> {context.getTranslation("common", "cancel")}</>}</MyContext.Consumer>}
                            />
                        </Stack.Item>
                    </Stack>
                </Stack.Item>
            </Stack>
        );
    }

    handleChange(text, id) {
        switch (id) {
            case 0:
                this.setState({ title: text });
                break;
            case 1:
                this.setState({ priority: text });
                break;
            case 2:
                this.setState({ state: text });
                break;
            case 3:
                this.setState({ description: text });
                break;
            case 4:
                this.setState({ contactEmail: text });
                break;

            default:
                break;
        }
        // Decide to set isChanged
        const currentEmail = id === 4 ? text : this.state.contactEmail;
        const isEmailValid = !currentEmail || this.validateEmail(currentEmail);
        if ((id === 0 ? text : this.state.title) !== "" && (id === 3 ? text : this.state.description) !== "" && isEmailValid) {
            this.setState({ isChanged: true });
        } else {
            this.setState({ isChanged: false });
        }
    }

    deleteFile = (index) => {
        this.setState(prevState => {
            const files = [...prevState.files];
            const fileToDelete = files[index];
            files.splice(index, 1);

            if (fileToDelete.annotationId !== null) {
                const deletedFiles = [...prevState.deletedFiles, { ...fileToDelete, isDeleted: true }];
                return { files, deletedFiles, isChanged: true };
            }

            return { files, isChanged: true };
        });
    };

    onFileChange = event => {
        let activeFile = event.target.files[0];

        if (activeFile) {
            this.setState({ isChanged: true });
            this.loadFile(activeFile);
        }
    };

    loadFile = async (file) => {
        let reader = new FileReader();
        reader.onloadend = () => {
            const newFile = {
                filename: file.name,
                mimeType: file.type,
                documentBody: reader.result,
                annotationId: null,
                isDeleted: false
            };

            this.setState(prevState => ({
                files: [...prevState.files, newFile]
            }));

        };
        reader.readAsDataURL(file);
    };

    notifyTenantChange = async (apol) => {
        const documents = [...this.state.files, ...this.state.deletedFiles];

        var ticket = {
            title: this.state.title,
            priority: this.state.priority,
            description: this.state.description,
            contactEmail: this.state.contactEmail,
            tenantId: this.state.tenantId,
            id: Utils.guidGenerator(),
            documents: documents,
        };

        var data = await apol.mutate({
            mutation: mutationCreateTicket,
            refetchQueries: [
                {
                    query: queryGetTickets,
                    variables: { input: this.props.authorization, tenantId: null, asPartner: true },
                },
            ],
            variables: {
                ticket: ticket,
            },
        });
        if (data.data.createTicket == null || !data.data.createTicket) {
            toast.info(<MyContext.Consumer>{(context) => <> {context.getTranslation("tenants", "addTicketNotSuccessful")}</>}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info(<MyContext.Consumer>{(context) => <> {context.getTranslation("tenants", "ticketAdded")}</>}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    _closeModal = () => {
        this.setState({ showModal: false });
    };

    _openModal = () => {
        this.setState({ showModal: true });
    };
}
